import { render, staticRenderFns } from "./SurveyAnswersCourseExit.vue?vue&type=template&id=7bf62680"
import script from "./SurveyAnswersCourseExit.vue?vue&type=script&lang=js"
export * from "./SurveyAnswersCourseExit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports